import { useEffect } from 'react'

// Sets the browser-tab title for the page that calls it. The site has a
// single static <title> in index.html otherwise, so without this every
// route shows the same tab title.
export const usePageTitle = title => {
	useEffect( () => {
		document.title = title
	}, [ title ] )
}
